export default __webpack_public_path__ + "assets/ireland-flag.png";